module.exports = __webpack_public_path__ + "img/jiankang1.8f8809cf.png";